<template>
  <div v-if="isUserAuthenticated()">
    <div v-html="contractHtml"></div>
  </div>
</template>

<script>
import auth from '@/auth'
import TemplateAdminComponent from '@/components/TemplateAdmin.vue'
import ModalContract from '@/components/ModalContract.vue'
import APIContract from '@/api/contract'
import APIInvoice from '@/api/invoice'
import {router} from '@/router'
const APIContractService = new APIContract();
const APIInvoiceService = new APIInvoice();
var axios = require('axios')

export default {

  components:
  {
    TemplateAdminComponent
  },

  mounted() {
  },

  data() {
    return {
      contractHtml: ""
    }
  },

  created(){
    this.initialize()
  },

  methods: {
    isUserAuthenticated() {
      return auth.isUserAuthenticated();
    },

    logout() {
      auth.logout()
    },

    async initialize () {
      var contractId = this.$route.params.ID
      if (contractId > 0)
      {
        await APIInvoiceService.generateInvoiceHtml(contractId).then(response =>  {
            this.contractHtml += response.data
          }
        )
      }
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/Invoice.vue